module.exports = __webpack_public_path__ + "static/media/Postales-10.72afaec4.png";